import Validators from './pzn/strategies'

const validatorInstances = {}
const DEFAULT_TENANT = 'com'

const getValidatorInstance = (tenant = DEFAULT_TENANT) => {
  if (!Validators[tenant]) {
    throw new Error(`Invalid tenant ${tenant}`)
  }

  if (!validatorInstances[tenant]) {
    validatorInstances[tenant] = new Validators[tenant]()
  }

  return validatorInstances[tenant]
}

export default getValidatorInstance
